import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleError, handleResponse } from 'src/functions/http-handler';
import { PrintService } from './print.service';
import { FileSaverService } from 'ngx-filesaver';
import { catchError, map, tap } from 'rxjs/operators';
import { IResponse } from 'src/models/response.model';
import { IPagedList } from 'src/models/paged-list.model';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReceiptConfirmService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private fileSaver: FileSaverService,
    private printSvc: PrintService,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/ReceiptConfirm`;
  }

  //get(param: any) {
  //  return this.http.get(this._apiUrl, { params: param })
  //    .pipe(
  //      tap((res) => this.logger.log('retrieve receipt-confirm', res)),
  //      catchError(handleError),
  //      map((data: IResponse) => {
  //        if (data.code == 'NoData') {
  //          return [];
  //        } else {
  //          return data.result;
  //        }
  //      })
  //    );
  //}
  get(param: any) {
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<IPagedList<IReceiptConfirm>>(this.logger, 'IReceiptConfirm get'));
  }

  export(param: any, type: 'sheet' | 'pdf') {
    const mimeType = (type == 'sheet') ? environment.mimeTypes.excel : environment.mimeTypes.pdf;
    const extension = (type == 'sheet') ? '.xlsx' : '.pdf';

    return this.http.get(`${this._apiUrl}/Export?type=${type}`, {
      headers: { 'Accept': mimeType },
      responseType: 'blob', // This must be a Blob type
      params: param
    }).subscribe((res: Blob) => {
      var filename = `ReceiptConfirm${extension}`;
      this.saveAsBlob(res, filename);
    });
  }

  create(ReceiptConfirm: Array<IReceiptConfirm>) {
    return this.http.post(this._apiUrl, ReceiptConfirm)
      .pipe(handleResponse<IReceiptConfirm>(this.logger, 'create Receipt Confirm'));
  }

  private saveAsBlob(data: any, filename: string) {
    const file = new File([data], filename, { type: environment.mimeTypes.excel });
    this.fileSaver.save(file, filename);
  }
}

export interface IReceiptConfirmRequest {
  vrCptId:string,
  packingSlipId: string,
  InventSiteId: number,
  origpurchId: string,
  inventTransId: string,
  vendAccount:string,
  vendAccountName: string,
  itemName: string,
  itemId: string,  
  qty: number,
  tymAqlType: string,
  inventDate: Date,
  confirm: string,
  confirmDate: Date,
  purchPrice: number,
  valueMst: number,
  taxAmount: number,
  gubun: string,
}


export interface IReceiptConfirm {
  PackingSlipId: string,
  InventSiteId: string,
  OrigpurchId: string,
  InventTransId: string,
  VendAccount: string,
  VendAccountName: string,
  ItemId:string,
  ItemName: string,
  Qty: number,
  PurchPrice: number,
  ValueMst: number,
  TaxAmount: number,
  PurchUnit: string,
  TymAqlType: string,
  ConfirmDate: Date,
  InventDate: Date,
  Gubun: string,
  Confirm: string,
  AuthType : string,
  scriptReturn: string,
}
